import { AbstractControl, ValidatorFn } from '@angular/forms';

// Custom validator class for auth related purposes
export class CustomAuthValidators {
    constructor() {}

    static usernameValidator(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            //Matches a whole string composed of characters, digits and some special chars.
            const matches = /^[a-zA-Z0-9._@+-]+$/.test(control.value);

            return matches ? null : { invalid: true };
        };
    }

    static passwordStrengthValidator(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            if (!control) return null;

            //Reset validation if value is empty
            if (!control.value || control?.value?.length === 0) return null;

            const hasMinLength = control?.value?.length >= 6;
            const hasNumber = /[0-9]/.test(control.value);
            const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(control.value);

            const isValid = hasMinLength && hasNumber && hasSpecialChar;
            return isValid ? null : { weakPassword: true };
        };
    }
}
